import React, { FunctionComponent } from "react";
import { FormSection } from "../../../FormSection";
import { Grid, MenuItem } from "@mui/material";
import { DropdownValue } from "../../../../types/DropdownValue";
import { SectionProps } from "../props";
import { CustomSelect } from "../../../CustomSelect";
import { CustomDatePicker } from "../../../CustomDatePicker";
import { User } from "../../../../model/User";

type SaleInformationState = {
  isLeadOutcomeSale: boolean;
  saleStatus: string;
  dropdownSaleItems: DropdownValue[];
  saleDate: Date | null | undefined;
  orderDate: Date | null | undefined;
  shipDate: Date | null | undefined;
  installDate: Date | null | undefined;
};

type OnChangeDate = (newValue: any) => void;

export const SaleInformation: FunctionComponent<
  SaleInformationState &
    SectionProps & {
      onChangeSaleDate: OnChangeDate;
      onChangeOrderDate: OnChangeDate;
      onChangeShipDate: OnChangeDate;
      onChangeInstallDate: OnChangeDate;
    }
> = (props) => {
  const user = new User();

  const showSaleStatus = !user.HasForbiddenAccess("Can See Sale Status");
  const showSaleDate = !user.HasForbiddenAccess("Can See Sale Date");
  const showOrderDate = !user.HasForbiddenAccess("Can See Order Date");
  const showShipDate = !user.HasForbiddenAccess("Can See Ship Date");
  const showInstallDate = !user.HasForbiddenAccess("Can See Install Date");
  const showSaleInfo =
    showSaleStatus ||
    showSaleDate ||
    showOrderDate ||
    showShipDate ||
    showInstallDate;

  const editSaleStatus = !user.HasForbiddenAccess("Can Edit Sale Status");
  const editSaleDate = !user.HasForbiddenAccess("Can Edit Sale Date");
  const editOrderDate = !user.HasForbiddenAccess("Can Edit Order Date");
  const editShipDate = !user.HasForbiddenAccess("Can Edit Ship Date");
  const editInstallDate = !user.HasForbiddenAccess("Can Edit Install Date");

  return showSaleInfo && props.isLeadOutcomeSale ? (
    <FormSection title="Sale Information" isCollapsible>
      {showSaleStatus && (
        <Grid item>
          <CustomSelect
            disabled={props.formDisabled || !editSaleStatus}
            name="saleStatus"
            label="Sales Status"
            value={props.saleStatus}
            onChange={props.onChangeSelect}
          >
            {props.dropdownSaleItems.map((item, index) => {
              return (
                <MenuItem key={index} value={item.id}>
                  {item.description}
                </MenuItem>
              );
            })}
          </CustomSelect>
        </Grid>
      )}
      {showSaleDate && (
        <Grid item>
          <CustomDatePicker
            disabled={props.formDisabled || !editSaleDate}
            name="saleDate"
            label={{ text: "Sale Date" }}
            value={props.saleDate}
            onChange={props.onChangeSaleDate}
          />
        </Grid>
      )}
      {showOrderDate && (
        <Grid item>
          <CustomDatePicker
            disabled={props.formDisabled || !editOrderDate}
            name="orderDate"
            label={{ text: "Order Date" }}
            value={props.orderDate}
            onChange={props.onChangeOrderDate}
          />
        </Grid>
      )}
      {showShipDate && (
        <Grid item>
          <CustomDatePicker
            disabled={props.formDisabled || !editShipDate}
            name="shipDate"
            label={{ text: "Ship Date" }}
            value={props.shipDate}
            onChange={props.onChangeShipDate}
          />
        </Grid>
      )}
      {showInstallDate && (
        <Grid item>
          <CustomDatePicker
            disabled={props.formDisabled || !editInstallDate}
            name="installDate"
            label={{ text: "Install Date" }}
            value={props.installDate}
            onChange={props.onChangeInstallDate}
          />
        </Grid>
      )}
    </FormSection>
  ) : null;
};
